import { ButtonProps } from '@stadionhq-v3/base-ui';
import { Button } from '../../button.component';

export const PrimaryButton = (props: ButtonProps) => (
  <Button variant="primary" {...props} />
);

export default PrimaryButton;
